
let menu = document.querySelector(".menu__lines"),
    nav = document.querySelector(".Navigation"),
    menuItem = document.querySelectorAll(".Navigation__list-item");


menuItem.forEach((e, t) => {
    e.addEventListener("click", function () {
        toggleMenu();
    });
}),
    menu.addEventListener("click", () => {
        toggleMenu();
    });
const toggleMenu = () => {
    menu.classList.toggle("show");
    nav.classList.toggle('showNav')
};

AOS.init({
  delay: 150,
  duration: 1300,
  easing: 'ease',
  once: true
})

/*------ PROJECT CARD CAROUSELS ------*/
document.querySelectorAll("[data-carousel]").forEach((carousel) => {
  const track = carousel.querySelector(".carousel__track");
  const slides = carousel.querySelectorAll(".carousel__slide");
  if (!track || slides.length <= 1) return; // single image: no controls

  let index = 0;

  const prev = document.createElement("button");
  prev.type = "button";
  prev.className = "carousel__btn carousel__btn--prev";
  prev.setAttribute("aria-label", "Previous image");
  prev.innerHTML = "&#8249;";

  const next = document.createElement("button");
  next.type = "button";
  next.className = "carousel__btn carousel__btn--next";
  next.setAttribute("aria-label", "Next image");
  next.innerHTML = "&#8250;";

  const dotsWrap = document.createElement("div");
  dotsWrap.className = "carousel__dots";

  const dots = Array.from(slides).map((_, i) => {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.className = "carousel__dot" + (i === 0 ? " is-active" : "");
    dot.setAttribute("aria-label", "Go to image " + (i + 1));
    dot.addEventListener("click", () => goTo(i));
    dotsWrap.appendChild(dot);
    return dot;
  });

  const goTo = (i) => {
    index = (i + slides.length) % slides.length;
    track.style.transform = "translateX(-" + index * 100 + "%)";
    dots.forEach((d, di) => d.classList.toggle("is-active", di === index));
  };

  prev.addEventListener("click", () => goTo(index - 1));
  next.addEventListener("click", () => goTo(index + 1));

  carousel.append(prev, next, dotsWrap);

  // basic touch/swipe support
  let startX = null;
  carousel.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  }, { passive: true });
  carousel.addEventListener("touchend", (e) => {
    if (startX === null) return;
    const diff = e.changedTouches[0].clientX - startX;
    if (Math.abs(diff) > 40) goTo(index + (diff < 0 ? 1 : -1));
    startX = null;
  });
});
